module.exports = __webpack_public_path__ + "img/wide.4ef7d187.jpg";